import React, { useState } from "react";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import PropTypes from "prop-types";
import "../../css/Login.css";

// ============================================================================
// MAIN COMPONENT
// ============================================================================
export default function PasswordInput({ value, onChange, placeholder, disabled }) {
    const [showPassword, setShowPassword] = useState(false);

    return (
        <div className="password-wrapper">
            <input
                type={showPassword ? "text" : "password"}
                value={value}
                onChange={(e) => onChange(e.target.value)}
                placeholder={placeholder || "Password"}
                disabled={disabled}
                required
            />
            <span
                className="password-toggle"
                onClick={() => setShowPassword(!showPassword)}
                role="button"
                tabIndex={0}
                aria-label={showPassword ? "Ocultar senha" : "Mostrar senha"}
                onKeyPress={(e) => e.key === "Enter" && setShowPassword(!showPassword)}
            >
                {showPassword ? <VisibilityOff fontSize="small" /> : <Visibility fontSize="small" />}
            </span>
        </div>
    );
}

PasswordInput.propTypes = {
    value: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    placeholder: PropTypes.string,
    disabled: PropTypes.bool,
};
